module.exports = "/assets/data/6e2d6a5b70c114c1f4298a2f827da3f2-NG1.data.json";